import {
  ALL_OPTIMIZATION_GOALS,
  type OptimizationGoal,
} from '@cast/shared-optimization-profiles';

import {
  ContinuousRebalancingConfig,
  KentAggressiveModeConfig,
} from '@cast/types-kent';

import { OPTIMIZATION_GOAL_TO_KENT_CONSOLIDATION_CONFIG } from './constants';

type AggressiveModeConfigKeys = keyof KentAggressiveModeConfig;

const getEnabledAggressiveModeConfigKeys = (
  config: ContinuousRebalancingConfig
): AggressiveModeConfigKeys[] => {
  const keys = Object.keys(
    config.aggressiveModeConfig || {}
  ) as AggressiveModeConfigKeys[];
  return keys.filter((key) => config.aggressiveModeConfig?.[key] === true);
};

const matchesKentConsolidationPreset = ({
  config,
  preset,
}: {
  config: ContinuousRebalancingConfig;
  preset: ContinuousRebalancingConfig;
}): boolean => {
  return (Object.keys(preset) as (keyof ContinuousRebalancingConfig)[]).every(
    (key) => {
      switch (key) {
        case 'aggressiveModeConfig': {
          const configEnabledAggressiveModeConfigKeys =
            getEnabledAggressiveModeConfigKeys(config);
          const presetEnabledAggressiveModeConfigKeys =
            getEnabledAggressiveModeConfigKeys(preset);
          return (
            configEnabledAggressiveModeConfigKeys.length ===
              presetEnabledAggressiveModeConfigKeys.length &&
            presetEnabledAggressiveModeConfigKeys.every((key) =>
              configEnabledAggressiveModeConfigKeys.includes(key)
            )
          );
        }

        default:
          return config[key] === preset[key];
      }
    }
  );
};

export const deriveKentConsolidationOptimizationGoal = ({
  config,
}: {
  config: ContinuousRebalancingConfig;
}): OptimizationGoal | undefined => {
  return ALL_OPTIMIZATION_GOALS.find((optimizationGoal) =>
    matchesKentConsolidationPreset({
      config,
      preset: OPTIMIZATION_GOAL_TO_KENT_CONSOLIDATION_CONFIG[optimizationGoal],
    })
  );
};
